module.exports = __webpack_public_path__ + "static/media/obgyn-top-icon.85201adc.svg";